import React from 'react';
import {connect} from 'react-redux'

import './App.css';

import DiscoveredList from "./components/bidib/DiscoveredList";
import ConnectionList from "./components/bidib/ConnectionList";


import {FiMenu} from "react-icons/fi";
import LogList from "./components/log/LogList";
import WorkspaceList from "./components/workspace/WorkspaceList";
import NodeTree from "./components/bidib/nodetree/NodeTree";
import NodeDetail from "./components/bidib/nodetree/NodeDetail";

function App({connected, data, log, setDone, app}) {

    const mynode = data && data.node && data.node.find(item => (item.path === "0.0.0.0" && item.linkrole === 2)) // why not?

    const hasWorkspace = app && app.workspace

    const _col = 4
    //const colums = hasWorkspace?_col+1:_col
    const xcol = hasWorkspace?' auto':''

    return (
        <div className="App">
            <div className="header">

                <div className={'headleft'}>
                    <FiMenu/>&nbsp;&nbsp;
                </div>

                <div className={'headright'}>
                    {mynode && mynode.version}
                </div>

            </div>
            <div className="log">
                <LogList data={log} setDone={setDone}/>
            </div>
            <div className="content">


                {connected
                    ?
                    <div style={{
                        display: "grid",
                        //gridTemplateColumns: `repeat(${colums}, auto)`,
                        //gridTemplateColumns: `300px 300px 300px auto ${xcol}`

                        gridTemplateColumns: `auto auto auto auto ${xcol}`,

                        height: '50%',
                        //background: 'white',
                    }}>
                        <DiscoveredList/>
                        <ConnectionList data={data.connections} records={data.records}/>

                        {hasWorkspace?<WorkspaceList/>:null}

                        <NodeTree/>

                        <NodeDetail nodeid={4711} />

                    </div>
                    :
                    <div
                        style={{
                            paddingTop: 100,
                        }}
                    >
                        loading ...
                    </div>}
            </div>
        </div>
    )
}

//  <ClientList data={data.clients}/>
//<LcList data={data.lcs}/>
//<NodeList />
// data={data.nodes}

function mapStateToProps(state, other) {

    return {data: state.bidib.data, app: state.bidib.data.app}
}

export default connect(mapStateToProps)(App)

